export default "__VITE_ASSET__3445aba7__"